import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import WpPostDetail from './WpPostDetailComponent';
import {
  selectWpPostLoadingById,
  selectWpPostErrorMessageById,
  selectWpPostById,
  selectRelatedPostById,
} from './selectors';
import { requestWpPost, requestRelatedPost } from './actions';
import Hashids from 'hashids/cjs';
const hashids = new Hashids('', 12);

const mapStateToProps = (state, props) => {
  const { match: { params } } = props;
  const postId = hashids.decode(params.postId)[0];
  console.log('Post ID:');
  console.log(postId);
  return {
    loading: selectWpPostLoadingById(postId)(state),
    errorMessage: selectWpPostErrorMessageById(postId)(state),
    item: selectWpPostById(postId)(state),
    related: selectRelatedPostById(postId)(state),
  };
};

function mapDispatchToProps(dispatch) {
  return {
    loadItem: (postId) => dispatch(requestWpPost(postId)),
    loadRelatedItem: (post) => dispatch(requestRelatedPost(post)),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WpPostDetail));
